import { Injectable, inject } from '@angular/core'
import { BehaviorSubject, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { SessionAuthorization } from '@models/api.interface';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    public sessionUUID = '';
    public userId = '';
    public userEmail = '';
    public officeIds: (string | number)[] = [];
    public accessObjectIds: (string | number)[] = [];
    public accessObjectUniqueName$ = new BehaviorSubject<string[]>([])
    public isBetaUser$ = new BehaviorSubject<boolean>(false);
    public features$ = new BehaviorSubject<string[]>([])
    public token: string | null = null;

    private http = inject(HttpClient);

    fetchAndStoreToken(sessionUUID: string) {
        const { root, path } = environment.url.api;
        const url = `${root}${path.auth}?session_uuid=${sessionUUID}`;
        return this.http.get<SessionAuthorization[]>(url).pipe(
            tap(response => {
                const sessionAuth = response[0];
                if (sessionAuth && sessionAuth.token) {
                    this.token = sessionAuth.token;
                    localStorage.setItem('jwt_token', sessionAuth.token);
                }
            })
        );
    }
}
